import { render, staticRenderFns } from "./PinButton.vue?vue&type=template&id=5a3e30dc&scoped=true"
import script from "./PinButton.vue?vue&type=script&lang=ts"
export * from "./PinButton.vue?vue&type=script&lang=ts"
import style0 from "./PinButton.vue?vue&type=style&index=0&id=5a3e30dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e30dc",
  null
  
)

export default component.exports